import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { UnifiedModal, ModalButton } from '@/components/common/UnifiedModal';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

const WarningIcon = SVG_COMPONENTS.WARNING;

interface ConfirmationModalProps {
  visible: boolean;
  message: string;
  onCancel: () => void;
  onProceed: () => void;
  cancelText?: string;
  proceedText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  visible,
  message,
  onCancel,
  onProceed,
  cancelText = 'No, cancel',
  proceedText = 'Proceed',
}) => {
  const { colors } = useThemeColors();

  const footer = (
    <View style={styles.footerButtons}>
      <ModalButton label={cancelText} onPress={onCancel} variant="secondary" />
      <ModalButton label={proceedText} onPress={onProceed} variant="primary" />
    </View>
  );

  return (
    <UnifiedModal
      visible={visible}
      onClose={onCancel}
      variant="dialog"
      dialogSize="compact"
      showHeader={true}
      footer={footer}
    >
      <View style={styles.content}>
        <View style={styles.messageBox}>
          <View style={styles.iconContainer}>
            <WarningIcon width={48} height={48} color={colors.text.muted} />
          </View>
          <Text style={[styles.messageText, { color: colors.text.primary }]}>{message}</Text>
        </View>
      </View>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  content: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageBox: {
    paddingHorizontal: 32,
    paddingVertical: 24,
    alignItems: 'center',
    gap: 16,
  },
  iconContainer: {
    width: 48,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageText: {
    fontSize: 16,
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: 24,
  },
  footerButtons: {
    flexDirection: 'row',
    gap: 16,
  },
});
